module.exports = __webpack_public_path__ + "google_pixel-silver@2x.png?04f7ef023bf17b5c0f6772401a1d12a8";